import { schema } from 'normalizr';

const pollOptionSchema = new schema.Entity('pollOptions', {});

export default pollOptionSchema;
